// Generated types for TextPart
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ResponsePartReadAPI, ResponsePartWriteAPI } from './responsepart';
import { ResponsePartReadAPISchemaObject, ResponsePartWriteAPISchemaObject } from './responsepart';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface TextPartReadAPI extends ResponsePartReadAPI {
  /** The text content */
  content?: string;
  /** Whether this text is being streamed */
  is_streaming?: boolean;
  /** Provider that produced this part (required when provider_details carries a signature). */
  provider_name?: string | null;
  /** Opaque provider metadata (e.g. Gemini thought_signature on the final part). */
  provider_details?: Record<string, unknown> | null;
}

export interface TextPartWriteAPI extends ResponsePartWriteAPI {
  /** The text content */
  content?: string;
  /** Whether this text is being streamed */
  is_streaming?: boolean;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const TextPartReadAPISchema: z.ZodType<TextPartReadAPI> = ResponsePartReadAPISchemaObject.extend({
  content: z.string().optional(),
  is_streaming: z.boolean().optional(),
  provider_name: z.string().nullable().optional(),
  provider_details: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.record(z.string(), z.unknown()).nullable()).optional(),
}).passthrough();

export const TextPartWriteAPISchema: z.ZodType<TextPartWriteAPI> = ResponsePartWriteAPISchemaObject.extend({
  content: z.string().optional(),
  is_streaming: z.boolean().optional(),
}).passthrough();
